import uuid from '../../lib/utils/uuid'
import { notifyAck, notifyNack, notifyDisconnect, dummyAction } from '../../actions/signaling'

export class ResponseMessageParser {
  constructor (transportMessageParser) {
    this.transportMessageParser = transportMessageParser
    this.parseMap = {
      'netop.rc.transport.Message': transportMessageParser.parse,
      'netop.rc.transport.Ack': () => notifyAck(),
      'netop.rc.transport.Nack': () => notifyNack(),
      'netop.rc.transport.Disconnect': () => notifyDisconnect()
    }
  }

  default = (/* type */) => () => {
    // ignore silently the messages with unknown type
    return dummyAction()
  }

  parse = (binaryMessage) => {
    const message = proto.netop.rc.base.NRCMessageType.deserializeBinary(binaryMessage)
    const type = message.getNetopMessageType()

    const parser = this.parseMap[type] || this.default(type)
    return parser(binaryMessage)
  }
}

/**
 * for test purposes; will be deleted later
 */
export function createResponseMessage () {
  // answer
  const answer = new proto.netop.rc.signaling.Answer()
  answer.setMessageType(proto.netop.rc.signaling.SignalingMessageType.ANSWER)
  answer.setSdp('sdp')
  const answerBinary = answer.serializeBinary()

  // route meta
  const routeMeta = new proto.netop.rc.route.Meta()
  routeMeta.setId(uuid.v1())

  const routeMsg = new proto.netop.rc.route.RouteMessage()
  routeMsg.setNetopMessageType('netop.rc.route.RouteMessage')
  routeMsg.setMeta(routeMeta)
  routeMsg.setTo('address')
  routeMsg.setBody(answerBinary)
  const routeMsgBinary = routeMsg.serializeBinary()

  // route meta
  const transportmeta = new proto.netop.rc.transport.Meta()
  transportmeta.setId(uuid.v1())

  // response
  const msg = new proto.netop.rc.transport.Message()
  msg.setNetopMessageType('netop.rc.transport.Message')
  msg.setMeta(transportmeta)
  msg.setBody(routeMsgBinary)
  const msgBinary = msg.serializeBinary()

  return msgBinary
}
